<div class="competency-page">
  <!-- <app-header></app-header>
  <app-breadcrumb></app-breadcrumb> -->
  <div class="h1 competency_div">
    Competency
  </div>
  <div class="competency-cards">
    <div class="card-row">
      <div class="card" style="background-image: url('../../../assets/images/updated-icons/Digital.png');">
        <div class="card-content">
          <h2 class="h1 card-headings">Digital</h2>
          <h2 class="h1 card-headings">Engineering</h2>
        </div>
        <div class="reveal-div">
          <div class="reveal-div-inner">
            Digital engineering is the transformative fusion of traditional engineering principles with cutting-edge
            technology, enabling the creation and optimization of innovative solutions in the digital realm.
          </div>
          <i class='fas fa-arrow-circle-left learn-more-arrow' style='font-size:24px;'></i>

        </div>
      </div>

      <div class="card" style="background-image: url('../../../assets/images/updated-icons/cyber_security.png');">
        <div class="card-content">
          <h2 class="h1 card-headings">Cyber</h2>
          <h2 class="h1 card-headings">Security</h2>
        </div>
        <div class="reveal-div">
          <div class="reveal-div-inner">
            Cybersecurity is the critical practice of protecting digital systems, networks, and information from
            unauthorized access, cyber threats, and data breaches to ensure the confidentiality, integrity, and
            availability of digital assets.
          </div>
          <i class='fas fa-arrow-circle-left learn-more-arrow' style='font-size:24px;'></i>


        </div>
      </div>

      <div class="card" style="background-image: url('../../../assets/images/updated-icons/Cloud.png');">
        <div class="card-content">
          <h2 class="h1 card-headings">Cloud</h2>
          <h2 class="h1 card-headings">Engineering</h2>

        </div>
        <div class="reveal-div">
          <div class="reveal-div-inner">
            Cloud engineering is the strategic discipline that leverages cloud computing technologies and principles to
            design, build, and manage scalable, secure, and cost-effective solutions for businesses and individuals in
            the digital era.
          </div>

          <i class='fas fa-arrow-circle-left learn-more-arrow' style='font-size:24px;'></i>

        </div>
      </div>

      <div class="card" style="background-image: url('../../../assets/images/updated-icons/cognative.png');">
        <div class="card-content">
          <h2 class="h1 card-headings">Cognative</h2>
          <h2 class="h1 card-headings">Computing</h2>

        </div>
        <div class="reveal-div">
          <div class="reveal-div-inner">

            Cognitive computing refers to the field of artificial intelligence that focuses on developing systems
            capable of mimicking human thought processes, such as perception, reasoning, and learning, to enhance
            decision-making and problem-solving in various verticals.
          </div>

          <i class='fas fa-arrow-circle-left learn-more-arrow' style='font-size:24px;'></i>

        </div>
      </div>

      <div class="card" style="background-image: url('../../../assets/images/updated-icons/dataServices.png');">
        <div class="card-content">
          <h2 class="h1 card-headings">Data</h2>
          <h2 class="h1 card-headings">Services</h2>

        </div>
        <div class="reveal-div">
          <div class="reveal-div-inner">
            Data services encompass a wide range of offerings and solutions that facilitate the collection, storage,
            processing, analysis, and utilization of data, enabling organizations to derive valuable insights, make
            informed decisions, and drive innovation in the digital age.
          </div>
          <i class='fas fa-arrow-circle-left learn-more-arrow' style='font-size:24px;'></i>

        </div>
      </div>

      <div class="card" style="background-image: url('../../../assets/images/updated-icons/emergin.png');">
        <div class="card-content">
          <h2 class="h1 card-headings">Emerging</h2>
          <h2 class="h1 card-headings">Technologies</h2>

        </div>
        <div class="reveal-div">
          <div class="reveal-div-inner">
            Emerging technologies refer to innovative and transformative advancements in various fields, such as
            artificial intelligence, blockchain, quantum computing, augmented reality, and more, that have the potential
            to revolutionize industries, drive societal change, and reshape the way we live and work in the future.
          </div>
          <i class='fas fa-arrow-circle-left learn-more-arrow' style='font-size:24px;'></i>

        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>